module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse",
      "variant": "inverse"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("F13 API Browser")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    staticClass: "left-nav",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": "/",
      "exact": true
    }
  }, [_vm._v("Events By ID")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/events",
      "exact": true
    }
  }, [_vm._v("Event Search")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "href": "http://docs.ingresso.co.uk/",
      "target": "_blank"
    }
  }, [_vm._v("API Docs")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7a338d8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 18
// module chunks = 0